import { render } from "./AppDropdown.vue?vue&type=template&id=764e9f2a"
import script from "./AppDropdown.vue?vue&type=script&lang=js"
export * from "./AppDropdown.vue?vue&type=script&lang=js"

import "./AppDropdown.vue?vue&type=style&index=0&id=764e9f2a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__